import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { SchoolClient } from "../../parentApi";

const client = new SchoolClient(app_uri, axiosClient());

export default client;
